module.exports = __webpack_public_path__ + "img/highlights3.2117d12e.png";